import styled from 'styled-components';
import {Modal, ModalTwoButtonsWrapper} from '@guestapp/old-ui-kit';

export const StyledModal = styled(Modal)``;

export const ModalTwoButtons = styled(ModalTwoButtonsWrapper)`
  margin-top: auto;
`;
